// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"b5c15e3c","477":"487e7fea","616":"35d9f9f0"}[chunkId] + ".chunk.css";
};